module.exports = __webpack_public_path__ + "img/Blockiert.2e64ccd8.svg";